import React from 'react';
import { useTranslation } from 'react-i18next';

import { Select, TextArea, Form } from '@weezevent/nacre';

export const ActionComment = React.memo(({ locale, action, comment, choice, setChoice, onChange }) => {
    const { t } = useTranslation();
    const { comment_choices, comment_editable, comment_required } = action;

    const choicesOptions = React.useMemo(() => {
        if (!comment_choices.length) {
            return [];
        }
        const lng = locale?.replace('_', '-').toLowerCase() || 'en-gb';
        return comment_choices.map(ch => ({
            text: ch.label,
            value: ch.translations.comment[lng],
            key: ch.id
        }));
    }, [comment_choices]);

    const handleChoice = React.useCallback(
        (key, text, value) => {
            setChoice(value ? { id: key, label: text, value } : null);
            onChange(value);
        },
        [onChange]
    );

    if (comment_required === null) {
        return null;
    }

    return (
        <>
            {!!comment_choices.length && (
                <Form.Field>
                    <Form.Label label={t('ticket.common.comment')} optionalText={!comment_required && t('ticket.common.labelOptionalParenthesis')} />
                    <Select
                        useNew
                        value={choice?.value}
                        onChange={(_, { key, text, value }) => handleChoice(key, text, value)}
                        onClear={() => handleChoice(null)}
                        options={choicesOptions}
                        placeholder={t('ticket.common.action.select')}
                    />
                </Form.Field>
            )}
            <Form.Field>
                <Form.Label label={t('ticket.moderation.attendee.moderationModal.addComment')} optionalText={!comment_required && t('ticket.common.labelOptionalParenthesis')} />
                <TextArea value={comment} onChange={({ target: { value } }) => onChange(value)} disabled={!comment_editable} />
            </Form.Field>
        </>
    );
});
